export class VerifyCodeRequest {
  email: string;
  code: string;
}
